import SubtemplateStore from 'notebook/entry-templates/SubtemplateStore';
import {
  FromServerSubtemplate,
  Subtemplate,
  TemplateCollection,
  ToServerSubtemplate,
} from 'notebook/entry-templates/TemplateConstants';
import {ACTION_CREATE_NEW_DRAFT} from 'notebook/store/VersioningConstants';
import EntityStore from 'stores/EntityStore';
import * as net from 'util/Net';

export interface SubtemplatesByVersion {
  [subtemplateVersion: string]: Array<Subtemplate>;
}

const SubtemplateDAO = {
  get: (id: string, forInsert?: boolean): Promise<FromServerSubtemplate> => {
    const data = {
      forInsert,
    };
    return net.getJSONPromise(`/1/api/subtemplates/${id}`, data);
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  create: ({name, templateCollectionId}: {name: string; templateCollectionId: string}) => {
    const data = {
      name,
      templateCollection: templateCollectionId,
    };
    return net.postJSONPromise({url: '/1/api/subtemplates/', data});
  },

  update: (id: string, data: ToServerSubtemplate): Promise<FromServerSubtemplate> =>
    net.patchJSONPromise({url: `/1/api/subtemplates/${id}`, data}),

  delete: (id: string): Promise<{}> => net.deletePromise({url: `/1/api/subtemplates/${id}`}),

  fetchCollection: (id: string): Promise<TemplateCollection> =>
    net.getJSONPromise(`/1/api/template-collections/${id}`),

  fetchCollections: (level: string): Promise<Array<TemplateCollection>> =>
    net.getJSONPromise('/1/api/template-collections/', {level}).then(({data}) => data),

  getVersions: (id: string): Promise<SubtemplatesByVersion> =>
    net.getJSONPromise(`/1/api/subtemplates/${id}/versions/`),

  getVersion: (id: string, versionId: string | number): Promise<FromServerSubtemplate> =>
    net.getJSONPromise(`/1/api/subtemplates/${id}/versions/${versionId}`),

  subtemplateURL: (subtemplateId: string): string =>
    `/${EntityStore.currentUser().url_identifier}/subtemplates/${subtemplateId}`,

  publishVersion: (
    subtemplateId: string,
    versionId: string,
    versionName: string,
    versionDescription?: string
  ): Promise<{publishingRecordId: string}> =>
    net.postJSONPromise({
      url: `/1/api/subtemplates/${subtemplateId}/versions/${versionId}:publish`,
      data: {versionName, versionDescription},
    }),

  withdrawVersion: (subtemplateId: string, versionId: string): Promise<{publishingRecordId: string}> =>
    net.patchJSONPromise({url: `/1/api/subtemplates/${subtemplateId}/versions/${versionId}:withdraw`}),

  createDraftFromVersion: (
    subtemplateId: string,
    versionId: string
  ): Promise<{
    draftSubtemplateVersionId: string;
    draftSubtemplateVersionDbId: number;
  }> => {
    const {metadata} = SubtemplateStore.getEditorState(subtemplateId);
    return net.postJSONPromise({
      url: `/1/api/subtemplates/${subtemplateId}/versions/${versionId}:create_draft`,
      data: {metadata: {...metadata, action: ACTION_CREATE_NEW_DRAFT}},
    });
  },
};

export default SubtemplateDAO;
